
import 'bootstrap/dist/css/bootstrap.min.css';
import 'devextreme/dist/css/dx.light.css'; // Veya kullandığınız tema

import { loadMessages, locale } from 'devextreme/localization';
import trMessages from 'devextreme/localization/messages/tr.json';
import * as serviceWorker from './serviceWorker';

import 'moment/locale/tr';
import React, { Fragment, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import 'react-dropzone-uploader/dist/styles.css';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import { ScrollContext } from 'react-router-scroll-4';
import { toast } from 'react-toastify';
import './assets/css/dia.css';
import './assets/css/fonts.css';
import App from "./components/app";
import CustomContext from './context/context';
import configDB from './data/customizer/config';
import './datagrid-style.css';
import './index.css';
import './index.scss';
import MainPage from './pages/MainPage';
import GuncelDurum from './pages/Raporlar/GuncelDurum/GuncelDurum.js';
import Raporlar from './pages/Raporlar/RaporListesi/RaporListesi.js';
import PeronRaporu from './pages/Raporlar/peron-raporu/PeronRaporu.js';
import Login from './pages/VeriGiris/Login.js';
import ForgetPwd from './pages/VeriGiris/forgetPwd.js';
import AdreslemeConfig from './pages/adresleme-config/AdreslemeConfig.js';
import IsLoggedIn from './pages/apiCall/IsLoggedIn.js';
import AracSorgulama from './pages/arac-sorgula/AracSorgulama.js';
import BlokajEkle from './pages/blokaj-sevk-bilgisi/BlokajEkle.js';
import BlokajSevkYeriExcel from './pages/blokaj-sevk-bilgisi/BlokajSevkYeriExcel.js';
import DepoCikis from './pages/depo-cikis/DepoCikis.js';
import DepoGiris from './pages/depo-giris/DepoGiris.js';
import AdresDegistirme from './pages/depo-yonetimi/Adres/AdresDegistirme.js';
import { default as AdresDetaylari } from './pages/depo-yonetimi/Adres/AdresDetaylari.js';
import AdrestekiAraclariBosalt from './pages/depo-yonetimi/Adres/AdrestekiAraclariBosalt.js';
import BolgeDetaylari from './pages/depo-yonetimi/Bolge/BolgeDetaylari.js';
import DepoDetaylari from './pages/depo-yonetimi/Depo/DepoDetaylari.js';
import DepolarArasiTransfer from './pages/depolar-arasi-transfer/DepolarArasiTransfer.js';
import DepolarArasiTransferIzleme from './pages/depolar-arasi-transfer/DepolarArasiTransferIzleme.js';
import DepolarArasiGrupajHazirlama from './pages/depolar-arasi-transfer/DepolarArasıTransferGrupaj.js';
import EtiketYazdir from './pages/etiket-yazdir/EtiketYazdir.js';
import { FiktifCikis } from './pages/fiktif-cikis/FiktifCikis.js';
import { GemiAracGiris } from './pages/gemi-arac-giris/GemiAracGiris.js';
import { FabrikaCikis } from './pages/fabrika-cikis/FabrikaCikis.js';
import GemiTahliyeExcel from './pages/gemi-tahliye-excel/GemiTahliyeExcel.js';
import FaturaVerileriYukle from './pages/grupaj-excel/FaturaVerileriYukle.js';
import GrupajHazırlama from './pages/grupaj/grupaj-hazirlama/GrupajHazırlama.js';
import GumruklendiBilgisi from './pages/gumruklendi-excel-girisi/GumruklendiBilgisi.js';
import GumrukluSahaCikisExcel from './pages/gumruklu-saha-cikis-excel/gumruklu-saha-cikis-excel.js';
import HasarBildirimi from './pages/hasar-bildirimi/HasarBildirimi.js';
import { HasarlidanCikis } from './pages/hasarli-cikis/HasarlidanCikis.js';
import { BayiIade, TruckApproval } from './pages/kapi-cikis/KapiCikis.js';
import { ChassisExit, GroupageExit } from './pages/kapi-cikis/KapiCikisV2.js';

import KullaniciRolYonetimi from './pages/kullanici-ve-rol-yonetimi/KullaniciRolYonetimi/kullanici-rol-yonetimi.js';
import KullaniciYonetimi from './pages/kullanici-ve-rol-yonetimi/KullaniciYonetimi/kullanici-yonetimi.js';
import YetkiGrupYonetimi from './pages/kullanici-ve-rol-yonetimi/YetkiGrupYonetimi/yetki-grup-yonetimi.js';
import LimanGiris from './pages/liman-giris/LimanGiris.js';
import ManuelSevkEmri from './pages/manuel-sevk-emri/ManuelSevkEmri.js';
import OnayEkrani from './pages/onay-ekrani/OnayEkrani.js';
import OnceliklendirmeExcel from './pages/onceliklendirme/OnceliklendirmeExcel.js';
import PDIEmirGiris from './pages/pdi-emir-yükle/PDIEmirGiris.js';
import PDIExcelGiris from './pages/pdi-excel/pdi-excel-giris.js';
import PDIExcelCikis from './pages/pdi-excel/pdi.excel-cikis.js';
import { PDICikisA2, PDIDonusA, PDIYapilmayacakA } from './pages/pdi/pdi.js';
import { PDIGirisA } from './pages/pdi/pdiV2.js';

import PeronKontrol from './pages/peron-kontrol/PeronKontrol.js';
import RihtimCikis from './pages/rihtim-cikis/RihtimCikis.js';
import RihtimIade from './pages/rihtim-iade/RihtimIade.js';
import SaseSorgulama from './pages/sase-sorgulama/SaseSorgulama.js';
import SaseTanimlama from './pages/sase-tanimlama/SaseTanimlama.js';
import SaseUyariGiris from './pages/sase-uyari/SaseUyariGiris.js';
import { SevkeHazirlama } from './pages/sevke-hazirlama/sevke-hazirlama.js';
import StokIzleme from './pages/stok-izleme/StokIzleme.js';
import AracMarkalari from './pages/tanimlamalar/arac-yonetimi/AracMarkalari.js';
import AracModelleri from './pages/tanimlamalar/arac-yonetimi/AracModelleri.js';
import RenkTanimalari from './pages/tanimlamalar/arac-yonetimi/RenkTanimalari.js';
import { AdresTanimlari } from './pages/tanimlamalar/sevkiyat-tanimlari/AdresTanimlari.js';
import { EmirTipi } from './pages/tanimlamalar/sevkiyat-tanimlari/EmirTipi.js';
import { IlTanimlari } from './pages/tanimlamalar/sevkiyat-tanimlari/IlTanimlari.js';
import { IlceTanimlari } from './pages/tanimlamalar/sevkiyat-tanimlari/IlceTanimlari.js';
import { ParkSoforleri } from './pages/tanimlamalar/sevkiyat-tanimlari/ParkSoforleri.js';
import { RotaTanimlama } from './pages/tanimlamalar/sevkiyat-tanimlari/RotaTanimlari.js';
import { SevkBolgeleri } from './pages/tanimlamalar/sevkiyat-tanimlari/SevkBolgeleri.js';
import { SevkiyatKMBilgileri } from './pages/tanimlamalar/sevkiyat-tanimlari/SevkiyatKMBilgileri.js';
import { SevkiyatTipi } from './pages/tanimlamalar/sevkiyat-tanimlari/SevkiyatTipi.js';
import { SevkiyatYerleri } from './pages/tanimlamalar/sevkiyat-tanimlari/SevkiyatYerleri.js';
import { TaseronFirmalar } from './pages/tanimlamalar/sevkiyat-tanimlari/TaseronFirmalar.js';
import TekliGrupajTırEsle from './pages/tekli-grupaj-tir-esle/TekliGrupajTırEsle.js';
import TransferGroupageForm from './pages/terminal-depolar-arasi-transfer/TerminalDepolarArasiTransfer.js';
// import WarehouseEntry from './pages/terminal-ekranlari/screens/WarehouseEntry.js';
import DepoGirisExcel from './pages/DepoGirisExcel/DepoGirisExcel.js';
import ExceldenRaporla from './pages/Raporlar/RaporListesi/ExceldenRaporla.js';
import RaporlarMusteri from './pages/Raporlar/Raporlar/RaporlarMusteri.js';
import DisDepoGrupajIptal from './pages/emir-silme/DışDepoGrupajIptal.js';
import EmirSilme from './pages/emir-silme/EmirSilme.js';
import GrupajHazirlamaV2 from './pages/grupaj/grupaj-hazirlama-v2/GrupajHazirlamaV2.js';
import GrupajIslemleriV2 from './pages/grupaj/grupaj-islemleri/GrupajIslemleriV2.js';
import HalTest from './pages/hal/HalTest.js';
import KanalTipi from './pages/kanal-tipi/KanalTipi.js';
import KapiCikisTeslimTarihi from './pages/kapi-cikis-teslim-tarihi/KapiCikisTeslimTarihleri.js';
import OtomatikAdresleme from './pages/otomatik-adresleme/OtomatikAdresleme.js';
import OzelTasimalar from './pages/ozel-tasimlar/OzelTasimalar.js';
import PDIExcelCikisIptal from './pages/pdi-excel/pdi-cikis-iptal.js';
import PDITamirDurum from './pages/pdi-tamir-durum/PDITamirDurum.js';
import InventoryCountList from './pages/sayim/sayim-form/SayimKayit.js';
import SayimTerminal from './pages/sayim/sayim-terminal/index.js';
import SevkiyatTakibi from './pages/sevkiyat-takibi/SevkiyatTakibi.js';
import PlakaIleGrupajSorgulama from './pages/tedarikci/PlakaIleGrupajSorgulama.js';
import TeslimBilgisi from './pages/tedarikci/TeslimBilgisi.js';
import TirEsleme from './pages/tedarikci/TirEsleme.js';
import TumSaseler from './pages/tum-saseler/TumSaseler.js';
import VeriIptali from './pages/veri-iptali/VeriIptali.js';
import HalApiLogs from './pages/veri-takibi/HalApiLogs.js';
import SevkBlokajKuyruk from './pages/veri-takibi/SevkBlokajKuyrukKayitlari.js';
import VeriTakibi from './pages/veri-takibi/VeriTakibi.js';
import YazıcıSecimi from './pages/yazici-secimi/YazıcıSecimi.js';
import YerindeAdresleme from './pages/yerinde-adresleme/YerindeAdresleme.js';
import OperasyonTakip from './pages/yonetici-ekranlari/OperasyonTakip.js';
import YoneticiEkranlari from './pages/yonetici-ekranlari/YoneticiEkranlari.js';
import api from './services/api-configuration.js';

function Root() {
    const abortController = new AbortController();
    var urlParams = new URLSearchParams(window.location.search);
    const notify = (message) => toast.error(message);
    if (localStorage.getItem("lang") === undefined || localStorage.getItem("lang") === null || localStorage.getItem("lang") === "") {
        localStorage.setItem("lang", "tr")
    }

    useEffect(() => {
        const layout = localStorage.getItem('layout_version') || configDB.data.color.layout_version
        sessionStorage.setItem('locale', 'tr')
        loadMessages(trMessages)
        locale("tr")

        document.body.classList.add(layout);

        console.ignoredYellowBox = ['Warning: Each', 'Warning: Failed'];
        console.disableYellowBox = true;

        return function cleanup() {
            abortController.abort();
        }

    }, [abortController]);

    if (urlParams.has('redirectPathMail')) {
        sessionStorage.setItem("RedirectPathMail", window.location.href.split("redirectPathMail=")[1])
    }
    if (localStorage.getItem("token") !== undefined) {
        localStorage.removeItem("token");
    }

    const [username, setUsername] = useState('')
    const [titleState, setTitleState] = useState('')
    const [firstname, setFirstname] = useState('')
    const [lastname, setLastname] = useState('')
    const [mailState, setMailState] = useState('')
    const [roleID, setRoleID] = useState(null);
    const [roles, setRoles] = useState([]); // We'll keep this for now but use it differently

    const fetchAuthroized = async (options) => {
        try {
            const response = await api.post("/checkRole", options);
            const result = response.data || [];
            const permittedRoles = result
                .filter(element => element?.permission === true)
                .map(element => element.role_name);

            return permittedRoles; // Now returning the array directly
        } catch (error) {
            console.error("Error fetching authorized roles:", error);
            return []; // Return empty array in case of error
        }
    };

    useEffect(() => {
        const fetchAndSetRoles = async () => {
            if (localStorage.getItem("employee_id") !== null &&
                localStorage.getItem("employee_id") !== undefined &&
                localStorage.getItem("employee_id") !== "") {

                const options = {
                    "employee_id": parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii')),
                    "role_group_ids": Array.isArray(roleID) ? roleID : [roleID]
                };

                if (roleID !== "" && roleID !== null) {
                    const fetchedRoles = await fetchAuthroized(options);
                    setRoles(fetchedRoles); // We'll update the state with the returned array
                }
            }
        };

        fetchAndSetRoles();
    }, [roleID]);
    const PrivateRoute = ({ allowed, component: Component, ...rest }) => (
        <Route
            {...rest}
            render={props => {
                let permission = false
                //const roles = JSON.parse(atob(Cookies.get("UserRoles1") + Cookies.get("UserRoles2") + Cookies.get("UserRoles3")))
                const roles = JSON.parse(atob(localStorage.getItem("roles")))
                if (roles.SpecialRoles !== null) {
                    if (roles.SpecialRoles.length !== 0) {
                        for (const special of roles.SpecialRoles) {
                            if (allowed.includes(special)) {
                                permission = true;
                                break;
                            } else {
                                if (roles.UserRole !== null) {
                                    if (roles.UserRoles.length !== 0) {
                                        for (const role of roles.UserRoles) {
                                            if (allowed.includes(role)) {
                                                permission = true;
                                                break;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    } else {
                        if (roles.UserRoles !== null) {
                            if (roles.UserRoles.length !== 0) {
                                for (const role of roles.UserRoles) {
                                    if (allowed.includes(role)) {
                                        permission = true;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }

                if (permission) {
                    return (
                        <Component {...props} />
                    )
                } else {
                    notify("Erişim yetkiniz yoktur.")
                    return (
                        <Redirect
                            to={{
                                pathname: "/index",
                                state: { from: props.location }
                            }}
                        />
                    )
                }
            }
            }
        />
    );


    return (
        <div className="App">
            <CustomContext.Provider value={{
                authState: {
                    userName: username,
                    title: titleState,
                    firstName: firstname,
                    lastName: lastname,
                    email: mailState,
                    roleID: roleID,
                    roles: roles
                },
                authActions: {
                    setUserName: setUsername,
                    setTitle: setTitleState,
                    setFirstName: setFirstname,
                    setLastName: setLastname,
                    setEmail: setMailState,
                    setRoleID: setRoleID,
                    setRoles: setRoles
                }
            }}>
                <BrowserRouter basename={`/`}>
                    <ScrollContext>
                        <Switch>

                            <Route path={`${process.env.PUBLIC_URL}/login`} component={Login} />
                            <Route exact path={`${process.env.PUBLIC_URL}/passwordreset/:UserId/:ExpireDate/:FullName`} component={ForgetPwd} />

                            <Fragment>
                                <App>
                                    {/* dashboard menu */}
                                    <Route path={`${process.env.PUBLIC_URL}/`} component={IsLoggedIn} />

                                    <Route exact path={`${process.env.PUBLIC_URL}/`} render={() => {
                                        return (<Redirect to={`${process.env.PUBLIC_URL}/login`} />)
                                    }} />
                                    <Route exact path={`${process.env.PUBLIC_URL}/passwordreset`} component={ForgetPwd} />
                                    <Route exact path={`${process.env.PUBLIC_URL}/index`} component={MainPage} />

                                    {/* Kullanıcı Yönetimi */}
                                    <PrivateRoute allowed={["kullaniciverol_yonetimi_read"]} path={`${process.env.PUBLIC_URL}/user-role-management/kullanici-rol-yonetimi`} component={KullaniciRolYonetimi} />
                                    <PrivateRoute allowed={["kullaniciverol_yonetimi_read"]} path={`${process.env.PUBLIC_URL}/user-role-management/yetki-grup-yonetimi`} component={YetkiGrupYonetimi} />
                                    <PrivateRoute allowed={["kullaniciverol_yonetimi_read"]} path={`${process.env.PUBLIC_URL}/user-role-management/kullanici-yonetimi`} component={KullaniciYonetimi} />

                                    <PrivateRoute allowed={["arac_sorgulama_read"]} path={`${process.env.PUBLIC_URL}/terminal/arac-sorgulama`} component={AracSorgulama} />
                                    <PrivateRoute allowed={["gemi_tahliye_read"]} path={`${process.env.PUBLIC_URL}/terminal/liman-giris`} component={LimanGiris} />

                                    <PrivateRoute allowed={["pdi_giris_read"]} path={`${process.env.PUBLIC_URL}/terminal/pdi-giris`} component={PDIGirisA} />
                                    <PrivateRoute allowed={["pdi_cikis_read"]} path={`${process.env.PUBLIC_URL}/terminal/pdi-cikis`} component={PDICikisA2} />
                                    {/* <PrivateRoute allowed={["pdi_cikis_read"]} path={`${process.env.PUBLIC_URL}/terminal/pdi-cikis-v2`} component={PDICikisA2} /> */}

                                    <PrivateRoute allowed={["pdi_giris_read"]} path={`${process.env.PUBLIC_URL}/terminal/pdi-yapilmayacak`} component={PDIYapilmayacakA} />
                                    <PrivateRoute allowed={["pdi_donus_read"]} path={`${process.env.PUBLIC_URL}/terminal/pdi-donus`} component={PDIDonusA} />

                                    <PrivateRoute allowed={["hasar_yonetimi_read"]} path={`${process.env.PUBLIC_URL}/hasar-bildirimi`} component={HasarBildirimi} />
                                    <PrivateRoute allowed={["depo_secimi_read"]} path={`${process.env.PUBLIC_URL}/terminal/yazici-secimi`} component={YazıcıSecimi} />
                                    <PrivateRoute allowed={["sase_sorgulama_read"]} path={`${process.env.PUBLIC_URL}/operasyon/sase-sorgulama`} component={SaseSorgulama} />
                                    <PrivateRoute allowed={["stok_izleme_read"]} path={`${process.env.PUBLIC_URL}/operasyon/stok-izleme`} component={StokIzleme} />
                                    <PrivateRoute allowed={["gumruklusaha_iade_read"]} path={`${process.env.PUBLIC_URL}/terminal/rihtim-iade`} component={RihtimIade} />

                                    <PrivateRoute allowed={["fiktif_cikis_read"]} path={`${process.env.PUBLIC_URL}/terminal/fiktif-cikis`} component={FiktifCikis} />
                                    <PrivateRoute allowed={["hasarli_cikis_read"]} path={`${process.env.PUBLIC_URL}/terminal/hasarlidan-cikis`} component={HasarlidanCikis} />
                                    <PrivateRoute allowed={["sevke_hazirlama_read"]} path={`${process.env.PUBLIC_URL}/terminal/sevke-hazirlama`} component={SevkeHazirlama} />
                                    <PrivateRoute allowed={["etiket_yazdir_read"]} path={`${process.env.PUBLIC_URL}/terminal/etiket-yazdir`} component={EtiketYazdir} />

                                    <PrivateRoute allowed={["peron_kontrol_read"]} path={`${process.env.PUBLIC_URL}/terminal/peron-kontrol`} component={PeronKontrol} />
                                    <PrivateRoute allowed={["gemi_tahliye_read"]} path={`${process.env.PUBLIC_URL}/terminal/gemi-arac-giris`} component={GemiAracGiris} />
                                    <PrivateRoute allowed={["fabrika_cikis_read"]} path={`${process.env.PUBLIC_URL}/terminal/fabrika-cikis`} component={FabrikaCikis} />
                                    <PrivateRoute allowed={["gemi_exceltahliye_read"]} path={`${process.env.PUBLIC_URL}/veri-yukle/gemi-tahliye`} component={GemiTahliyeExcel} />
                                    <PrivateRoute allowed={["gumruklendi_bilgisi_read"]} path={`${process.env.PUBLIC_URL}/veri-yukle/gumruklendi`} component={GumruklendiBilgisi} />
                                    <PrivateRoute allowed={["kanal_tipi_read"]} path={`${process.env.PUBLIC_URL}/veri-yukle/kanal-tipi`} component={KanalTipi} />

                                    <PrivateRoute allowed={["yerinde_adresleme_read"]} path={`${process.env.PUBLIC_URL}/terminal/yerinde-adresleme`} component={YerindeAdresleme} />
                                    <PrivateRoute allowed={["depo_cikis_read"]} path={`${process.env.PUBLIC_URL}/terminal/depo-cikis`} component={DepoCikis} />

                                    <PrivateRoute allowed={["onay_ekrani_read"]} path={`${process.env.PUBLIC_URL}/onay-ekrani`} component={OnayEkrani} />

                                    <PrivateRoute allowed={["pdi_emir_read"]} path={`${process.env.PUBLIC_URL}/pdi-emir`} component={PDIEmirGiris} />
                                    <PrivateRoute allowed={["ctyazilimparca_excel_read"]} path={`${process.env.PUBLIC_URL}/veri-yukleme/ct-yazilim-parca-tamir`} component={PDITamirDurum} />
                                    <PrivateRoute allowed={["sase_tanimlama_read"]} path={`${process.env.PUBLIC_URL}/sase-tanimlama`} component={SaseTanimlama} />

                                    <PrivateRoute allowed={["stok_izleme_read"]} path={`${process.env.PUBLIC_URL}/sase-list`} component={TumSaseler} />

                                    <PrivateRoute allowed={["depo_role_read"]} path={`${process.env.PUBLIC_URL}/depo-yonetimi/depo-tanim`} component={DepoDetaylari} />
                                    <PrivateRoute allowed={["bolge_role_read"]} path={`${process.env.PUBLIC_URL}/depo-yonetimi/bolge-tanim`} component={BolgeDetaylari} />
                                    <PrivateRoute allowed={["adres_role_read"]} path={`${process.env.PUBLIC_URL}/depo-yonetimi/adres-tanim`} component={AdresDetaylari} />
                                    <PrivateRoute allowed={["adres_guncelle_read"]} path={`${process.env.PUBLIC_URL}/depo-yonetimi/adresteki-araclari-bosalt`} component={AdrestekiAraclariBosalt} />
                                    <PrivateRoute allowed={["adres_guncelle_read"]} path={`${process.env.PUBLIC_URL}/depo-yonetimi/adres-degistirme`} component={AdresDegistirme} />
                                    <PrivateRoute allowed={["grupaj_islemeri_read"]} path={`${process.env.PUBLIC_URL}/grupaj/grupaj-hazirlama`} component={GrupajHazırlama} />
                                    <PrivateRoute allowed={["grupaj_islemeri_read"]} path={`${process.env.PUBLIC_URL}/grupaj/grupaj-hazirlama-v2`} component={GrupajHazirlamaV2} />
                                    {/* <PrivateRoute allowed={["grupaj_islemeri_read"]} path={`${process.env.PUBLIC_URL}/grupaj/grupaj-islemleri`} component={GrupajIslemleri} /> */}
                                    <PrivateRoute allowed={["grupaj_islemeri_read"]} path={`${process.env.PUBLIC_URL}/grupaj/grupaj-islemleri`} component={GrupajIslemleriV2} />

                                    <PrivateRoute allowed={["depogiris_excel_read"]} path={`${process.env.PUBLIC_URL}/veri-yukleme/depogiris`} component={DepoGirisExcel} />

                                    <PrivateRoute allowed={["arac_marka_read"]} path={`${process.env.PUBLIC_URL}/arac-yonetimi/marka`} component={AracMarkalari} />
                                    <PrivateRoute allowed={["arac_model_read"]} path={`${process.env.PUBLIC_URL}/arac-yonetimi/model`} component={AracModelleri} />
                                    <PrivateRoute allowed={["arac_renk_read"]} path={`${process.env.PUBLIC_URL}/arac-yonetimi/renk`} component={RenkTanimalari} />

                                    <PrivateRoute allowed={["pdiexcel_giris_read"]} path={`${process.env.PUBLIC_URL}/veri-yukle/pdi-giris`} component={PDIExcelGiris} />
                                    <PrivateRoute allowed={["pdiexcel_cikis_read"]} path={`${process.env.PUBLIC_URL}/veri-yukle/pdi-cikis`} component={PDIExcelCikis} />
                                    <PrivateRoute allowed={["pdiexcel_cikis_read"]} path={`${process.env.PUBLIC_URL}/veri-yukle/pdi-iptal`} component={PDIExcelCikisIptal} />


                                    <PrivateRoute allowed={["sevkiyat_tanimlari_read"]} path={`${process.env.PUBLIC_URL}/tanimlamalar/taseron-firmalar`} component={TaseronFirmalar} />
                                    <PrivateRoute allowed={["sevkiyat_tanimlari_read"]} path={`${process.env.PUBLIC_URL}/tanimlamalar/sevkiyat-tipi`} component={SevkiyatTipi} />
                                    <PrivateRoute allowed={["sevkiyat_tanimlari_read"]} path={`${process.env.PUBLIC_URL}/tanimlamalar/rota-tanimlama`} component={RotaTanimlama} />
                                    <PrivateRoute allowed={["sevkiyat_tanimlari_read"]} path={`${process.env.PUBLIC_URL}/tanimlamalar/sevkiyat-km-bilgileri`} component={SevkiyatKMBilgileri} />
                                    <PrivateRoute allowed={["sevkiyat_tanimlari_read"]} path={`${process.env.PUBLIC_URL}/tanimlamalar/emir-tanimlama`} component={EmirTipi} />
                                    <PrivateRoute allowed={["sevkiyat_tanimlari_read"]} path={`${process.env.PUBLIC_URL}/tanimlamalar/park-soforleri`} component={ParkSoforleri} />
                                    <PrivateRoute allowed={["sevkiyat_tanimlari_read"]} path={`${process.env.PUBLIC_URL}/tanimlamalar/sevkiyat-yerleri`} component={SevkiyatYerleri} />
                                    <PrivateRoute allowed={["sevkiyat_tanimlari_read"]} path={`${process.env.PUBLIC_URL}/tanimlamalar/sevk-bolgeleri`} component={SevkBolgeleri} />
                                    <PrivateRoute allowed={["sevkiyat_tanimlari_read"]} path={`${process.env.PUBLIC_URL}/tanimlamalar/adres-tanim`} component={AdresTanimlari} />
                                    <PrivateRoute allowed={["sevkiyat_tanimlari_read"]} path={`${process.env.PUBLIC_URL}/tanimlamalar/il-tanim`} component={IlTanimlari} />
                                    <PrivateRoute allowed={["sevkiyat_tanimlari_read"]} path={`${process.env.PUBLIC_URL}/tanimlamalar/ilce-tanim`} component={IlceTanimlari} />

                                    <PrivateRoute allowed={["fatura_giris_read"]} path={`${process.env.PUBLIC_URL}/veri-yukleme/fatura`} component={FaturaVerileriYukle} />
                                    <PrivateRoute allowed={["onceliklendirme_veri_read"]} path={`${process.env.PUBLIC_URL}/veri-yukleme/onceliklendirme`} component={OnceliklendirmeExcel} />
                                    <PrivateRoute allowed={["blokaj_sevk_read"]} path={`${process.env.PUBLIC_URL}/veri-yukleme/blokaj-sevk`} component={BlokajSevkYeriExcel} />
                                    <PrivateRoute allowed={["manuel_sevk_read"]} path={`${process.env.PUBLIC_URL}/veri-yukleme/manuel-sevk`} component={ManuelSevkEmri} />

                                    <PrivateRoute allowed={["depolararasi_emir_read", "depolararasi_emir_write"]} path={`${process.env.PUBLIC_URL}/depolar-arasi/transfer`} component={DepolarArasiTransfer} />
                                    <PrivateRoute allowed={["depolararasi_transfer_read"]} path={`${process.env.PUBLIC_URL}/depolar-arasi/izleme`} component={DepolarArasiTransferIzleme} />

                                    <PrivateRoute allowed={["sase_uyari_read"]} path={`${process.env.PUBLIC_URL}/veri-yukleme/sase-uyari-girisi`} component={SaseUyariGiris} />
                                    <PrivateRoute allowed={["genel_blokaj_read"]} path={`${process.env.PUBLIC_URL}/veri-yukle/blokaj`} component={BlokajEkle} />
                                    <PrivateRoute allowed={["gumruklu_saha_read"]} path={`${process.env.PUBLIC_URL}/terminal/rihtim-cikis`} component={RihtimCikis} />
                                    <PrivateRoute allowed={["adres_role_read"]} path={`${process.env.PUBLIC_URL}/depo-yonetimi/adresleme-config`} component={AdreslemeConfig} />
                                    <PrivateRoute allowed={["depolararasi_transfer_read"]} path={`${process.env.PUBLIC_URL}/operasyonlar/depolar-arasi-grupaj`} component={DepolarArasiGrupajHazirlama} />

                                    <PrivateRoute allowed={["grupaj_tir_read_only"]} path={`${process.env.PUBLIC_URL}/terminal/tekli-grupaj-tir-esle`} component={TekliGrupajTırEsle} />
                                    <PrivateRoute allowed={["depolararasi_transfer_read"]} path={`${process.env.PUBLIC_URL}/terminal/depo-transfer-grupaj`} component={TransferGroupageForm} />

                                    <PrivateRoute allowed={["tir_onay_read"]} path={`${process.env.PUBLIC_URL}/terminal/truck-approval`} component={TruckApproval} />
                                    {/* <PrivateRoute allowed={["tir_onay_read"]} path={`${process.env.PUBLIC_URL}/terminal/truck-approval`} component={TruckApproval} /> */}
                                    <PrivateRoute allowed={["grupaj_kapicikis_read"]} path={`${process.env.PUBLIC_URL}/terminal/groupage-exit`} component={GroupageExit} />
                                    <PrivateRoute allowed={["sase_kapicikis_read"]} path={`${process.env.PUBLIC_URL}/terminal/chassis-exit`} component={ChassisExit} />

                                    <PrivateRoute allowed={["depo_giris_read"]} path={`${process.env.PUBLIC_URL}/terminal/depo-giris`} component={DepoGiris} />
                                    <PrivateRoute allowed={["rapor_listesi_read"]} path={`${process.env.PUBLIC_URL}/raporlar/rapor-listesi`} component={Raporlar} />
                                    <PrivateRoute allowed={["rapor_musteri_read"]} path={`${process.env.PUBLIC_URL}/raporlar/raporlar`} component={RaporlarMusteri} />

                                    <PrivateRoute allowed={["peron_raporu_read"]} path={`${process.env.PUBLIC_URL}/raporlar/peron-raporu`} component={PeronRaporu} />
                                    <PrivateRoute allowed={["anlik_raporlar_rad"]} path={`${process.env.PUBLIC_URL}/raporlar/guncel-durum-ozeti`} component={GuncelDurum} />

                                    <PrivateRoute allowed={["bayi_iade_read"]} path={`${process.env.PUBLIC_URL}/terminal/bayi-iade`} component={BayiIade} />
                                    <PrivateRoute allowed={["otomatik_adresleme_read"]} path={`${process.env.PUBLIC_URL}/terminal/otomatik-adresleme`} component={OtomatikAdresleme} />
                                    <PrivateRoute allowed={["kapicikis_teslimtarihi_read"]} path={`${process.env.PUBLIC_URL}/veri-yukleme/kapi-cikis-teslim-tarihi`} component={KapiCikisTeslimTarihi} />
                                    <PrivateRoute allowed={["gumruklu_sahacikis_read"]} path={`${process.env.PUBLIC_URL}/veri-yukleme/gumruklu-saha-cikis`} component={GumrukluSahaCikisExcel} />

                                    <PrivateRoute allowed={["manuelsevk_iptal_read"]} path={`${process.env.PUBLIC_URL}/manuel-sevk-emiri-silme`} component={EmirSilme} />
                                    <PrivateRoute allowed={["disdepo_iptal_read"]} path={`${process.env.PUBLIC_URL}/dis-depo-transfer-iptal`} component={DisDepoGrupajIptal} />

                                    <PrivateRoute allowed={["canli_takip_yonetici_read"]} path={`${process.env.PUBLIC_URL}/canli-takip/yonetici-paneli`} component={YoneticiEkranlari} />
                                    <PrivateRoute allowed={["canli_takip_operasyon_read"]} path={`${process.env.PUBLIC_URL}/canli-takip/operasyon-takip`} component={OperasyonTakip} />

                                    <PrivateRoute allowed={["sevkiyat_takibi_read"]} path={`${process.env.PUBLIC_URL}/sevkiyat-takibi`} component={SevkiyatTakibi} />
                                    <PrivateRoute allowed={["excel_iptal_read"]} path={`${process.env.PUBLIC_URL}/veri-iptali`} component={VeriIptali} />
                                    <PrivateRoute allowed={["ozel_tasimalar_read"]} path={`${process.env.PUBLIC_URL}/ozel-tasimalar`} component={OzelTasimalar} />

                                    {/* Tedarikçi Routes */}
                                    <PrivateRoute allowed={["tedarikci_tir_read"]} path={`${process.env.PUBLIC_URL}/tedarikci/tir-esleme`} component={TirEsleme} />
                                    <PrivateRoute allowed={["tedarikci_teslim_read"]} path={`${process.env.PUBLIC_URL}/tedarikci/teslim-bilgisi`} component={TeslimBilgisi} />
                                    <PrivateRoute allowed={["arac_sorgulama_read"]} path={`${process.env.PUBLIC_URL}/tedarikci/plaka-ile-grupaj-sorgulama`} component={PlakaIleGrupajSorgulama} />

                                    <PrivateRoute exact allowed={["veri_takibi_read"]} path={`${process.env.PUBLIC_URL}/veri-takibi`} component={VeriTakibi} />
                                    <PrivateRoute exact allowed={["veri_takibi_read"]} path={`${process.env.PUBLIC_URL}/veri-takibi/hal-api-logs`} component={HalApiLogs} />
                                    <PrivateRoute exact allowed={["veri_takibi_read"]} path={`${process.env.PUBLIC_URL}/hal/test`} component={HalTest} />
                                    <PrivateRoute allowed={["excelden_raporlama_read"]} path={`${process.env.PUBLIC_URL}/raporlar/excelden-raporla`} component={ExceldenRaporla} />

                                    <PrivateRoute allowed={["sayim_terminal_read"]} path={`${process.env.PUBLIC_URL}/terminal/sayim`} component={SayimTerminal} />
                                    <PrivateRoute allowed={["sayim_ekleme_read"]} path={`${process.env.PUBLIC_URL}/operasyon/sayim`} component={InventoryCountList} />
                                    <PrivateRoute exact allowed={["tanimsiz_veritakibi_read"]} path={`${process.env.PUBLIC_URL}/veri-takibi/sevk-blokaj-takibi`} component={SevkBlokajKuyruk} />
                                </App>
                            </Fragment>
                            {
                                <Redirect to={`${process.env.PUBLIC_URL}/login`} />

                            }

                        </Switch>
                    </ScrollContext>
                </BrowserRouter>
            </CustomContext.Provider>
        </div>
    );
}

ReactDOM.render(<Root />, document.getElementById('root'));
serviceWorker.unregister();
